import { Component, input, model } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { ButtonComponent, ModalCloseDirective, PaginationComponent } from '@tdwb/core';

@Component({
  imports: [
    TranslateDirective,
    ButtonComponent,
    PaginationComponent,
    ModalCloseDirective
  ],
  selector: 'td-wb-modal-notification-footer',
  templateUrl: 'modal-notification-footer.component.html',
  styleUrls: ['modal-notification-footer.component.scss']
})
export class ModalNotificationFooterComponent {
  readonly totalSubModals = input(1);
  readonly step = model(1);
  readonly buttonText = input('tdWb.modalNotification.footer.OK');

  protected goToSelected(step: number): void {
    this.step.set(step);
  }
}
